'use client'

/* ---------------------------------
CampaignProgress
--------------------------------- */

import React, { ReactElement } from 'react'
import {
  Anchor,
  OpeningTitle,
  Paragraph,
  Section,
  Title,
} from '@dynamo-caffeina-dev/airc-ui-kit'
import Link from 'next/link'
import LinkArrowRight from '@/components/atoms/Icons/link-arrow'
import { SectionBackground } from '@/types'

// TODO this component is in stand-by ATM
type OwnProps = any

export default function CampaignProgress({
  props,
  modelledContent: extractedContent,
}: OwnProps): ReactElement | null {
  const { openingTitle, title, paragraph, cta, progressCard } =
    extractedContent ?? {}

  const { direction, distribution, bg } = props ?? {}

  const openingTitleLabel = openingTitle?.content
  const titleLabel = title?.content
  const paragraphContent = paragraph?.content
  const ctaLabel = cta?.label

  return (
    <Section
      bg={bg as SectionBackground | undefined}
      className={`section-image-text`}
      data-direction={direction ?? 'row'}
      data-distribution={distribution ?? 'text-image'}
    >
      <div className={`section-image-text__content-wrapper`}>
        <div className={`section-image-text__content-wrapper__title-wrapper `}>
          {openingTitleLabel ? (
            <OpeningTitle
              className={`section-image-text__content-wrapper__title-wrapper__opening-title`}
              {...openingTitle}
            >
              {openingTitleLabel}
            </OpeningTitle>
          ) : null}

          {titleLabel ? (
            <Title
              className={`section-image-text__content-wrapper__title-wrapper__title`}
              {...title}
              dangerouslySetInnerHTML={{ __html: titleLabel }}
            />
          ) : null}
        </div>

        {paragraphContent ? (
          <Paragraph
            // We override Paragraph's default alignment by following the Title's
            // alignment; this is needed because the WYSIWYG editor won't pass
            // any style for its default alignment (which is left).
            // If the user sets an alignment other than left in the WYSIWYG editor,
            // the resulting HTML with inline styles will override this alignment.
            alignment={title?.alignment}
            as={'div'}
            className={`section-image-text__content-wrapper__paragraph`}
            dangerouslySetInnerHTML={{ __html: paragraphContent }}
            {...paragraph}
          />
        ) : null}

        {cta && ctaLabel ? (
          <Anchor
            wrapper={'div'}
            data-alignment={cta?.alignment}
            className={`section-image-text__content-wrapper__cta link-button-themed`}
            // variant={'themed'}
            as={Link}
            {...cta}
          >
            {ctaLabel}
            <LinkArrowRight
              className={`section-image-text__content-wrapper__cta__icon`}
            />
          </Anchor>
        ) : null}
      </div>
    </Section>
  )
}
